"use client";
import { useRef } from "react";
import Image from "next/image";
import { useRouter } from "next/navigation"; 
import React from "react";
import Ro from "@/assets/2016-09-20_22-10-04.jpg";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import classes from "./styles/Items.module.css";
import Link from "next/link";

const categories = [
  { id: 1, title: "مواد پروتئینی", image: Ro },
  { id: 2, title: "لبنیات", image: Ro },
  { id: 3, title: "نوشیدنی‌ها", image: Ro },
  { id: 4, title: "تنقلات", image: Ro },
  { id: 5, title: "غلات و حبوبات", image: Ro },
  { id: 6, title: "چاشنی‌ها", image: Ro },
];

const CategoryGrid = () => {
  const router = useRouter();
  const sliderRef = useRef<HTMLDivElement>(null);

  const scrollRight = () => {
    if (sliderRef.current) {
      sliderRef.current.scrollBy({ left: 200, behavior: "smooth" });
    }
  };

  const scrollLeft = () => {
    if (sliderRef.current) {
      sliderRef.current.scrollBy({ left: -200, behavior: "smooth" });
    }
  };
//eslint-disable-next-line @typescript-eslint/no-unused-vars
  const handleClick = (id: number) => {
    // router.push(`/category/${id}`);
    router.push(`/category`);
  };

  return (
    <>
      <div className="flex items-center justify-between p-5 rounded-lg">
        <Link href={"/category"}>
          <div className="text-3xl font-bold mt-[50px] mr-[30px]">
            دسته بندی ها
          </div>
        </Link>
        <div className={classes.LRIcon}>
          <button
            className="bg-white text-gray-800 p-2 rounded-full hover:bg-gray-400 transition"
            onClick={scrollRight}
          >
            <FaChevronRight size={18} />
          </button>
          <button
            className="bg-white text-gray-800 p-2 rounded-full hover:bg-gray-400 transition"
            onClick={scrollLeft}
          >
            <FaChevronLeft size={18} />
          </button>
        </div>
      </div>

      <div className="relative overflow-hidden">
        <div
          ref={sliderRef}
          className="flex space-x-4 overflow-x-scroll scroll-smooth scrollbar-hide p-2"
          style={{
            scrollbarWidth: "none", // مخفی کردن اسکرول در فایرفاکس
            msOverflowStyle: "none", // مخفی کردن اسکرول در اینترنت اکسپلورر
          }}
        >
          {categories.map((category) => (
            <div
              key={category.id}
              className="items-center p-6 cursor-pointer"
              onClick={() => handleClick(category.id)}
            >
              <div className="w-[200px] h-[230px] rounded-[20px] bg-white to-gray-170 flex flex-col items-center justify-center mb-4">
                <Image
                  src={category.image}
                  alt={category.title}
                  className="w-[150px] h-[150px] object-contain"
                />
                <span className="text-lg font-medium mt-2">
                  {category.title}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default CategoryGrid;
